import React from "react";
import { Navigate } from "react-router-dom";
import { detectInitialLang } from "@/i18n";

// Root `/` -> redirect to detected/preferred language home.
export default function LangRedirect() {
  const lang = detectInitialLang();
  return <Navigate to={`/${lang}`} replace />;
}
